"use client";

import { IFilterablePaginatedSection } from "@faire/web-api/indigofair/data/IFilterablePaginatedSection";
import { useIsSSR } from "@faire/web/common/server-side-rendering/isSSR";
import React from "react";

import { Filter } from "@faire/retailer/components/Filters/Filter";
import { getSDUIFilterName } from "@faire/retailer/components/SDUI/__internal__/Filters/getSDUIFilterName";
import { SectionLoggingEventParams } from "@faire/retailer/components/SDUI/__internal__/types";
import { useFilterablePaginatedSectionQuery } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Fetching/useFilterablePaginatedSectionQuery";
import { SDUIFilterablePaginatedSectionFiltersLoadingSkeleton } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/LoadingSkeleton/SDUIFilterablePaginatedSectionFiltersLoadingSkeleton";
import { styledFilter } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/styles.css";

export const FilterablePaginatedSectionFiltersNonRSC: React.FC<{
  filterablePaginatedSection: IFilterablePaginatedSection;
  sectionLoggingData: SectionLoggingEventParams;
}> = ({ filterablePaginatedSection, sectionLoggingData }) => {
  const { isFilterLoading, filtersResponse } =
    useFilterablePaginatedSectionQuery(filterablePaginatedSection);
  const isSSR = useIsSSR();

  if ((!isFilterLoading && filtersResponse === undefined) || isSSR) {
    return <SDUIFilterablePaginatedSectionFiltersLoadingSkeleton />;
  }
  return (
    <Filter
      name={getSDUIFilterName(sectionLoggingData.view_display_page)}
      resultsCount={
        filtersResponse?.formatted_total_results_count ??
        `${filtersResponse?.total_results_count}` ??
        ""
      }
      isLoading={isFilterLoading}
      className={styledFilter}
      isSticky
      headerSeparator
    />
  );
};
